import React from 'react';

import PropTypes from 'prop-types';

import EstimatedDeliveryTime from '../../components/services/estimated-delivery-time';
import UserDateTimezoneFormat from '../../components/user-date-timezone-format';
import { UserDateTimePropType } from '../../prop-types/user-date-time';
import { isValidISOString } from '../../services/time-helper-service';

const DeliveryTime = ({ className, deliveryTime, emptyValue }) => {
  const isValidISO = isValidISOString(deliveryTime);

  return isValidISO ? (
    <div className={className}>
      <UserDateTimezoneFormat dateTime={deliveryTime} showTime spaceBetweenTimeAndZone />
    </div>
  ) : (
    <EstimatedDeliveryTime estimatedDeliveryTime={deliveryTime}>
      {({ normalizedDeliveryTime }) => <div className={className}>{normalizedDeliveryTime || emptyValue}</div>}
    </EstimatedDeliveryTime>
  );
};

DeliveryTime.propTypes = {
  className: PropTypes.string,
  deliveryTime: UserDateTimePropType,
  emptyValue: PropTypes.node,
};

export default DeliveryTime;
